import { useQuery } from '@tanstack/react-query';

import { useSearchParamsState } from '@pkg/hooks/navigation/useSearchParams';
import { type SupportedNetworkName } from '@pkg/types';

import { callGetDiscoverCollections } from '@app/client/resources/nbe/discover-request-handler/discover';

const DISCOVER_COLLECTIONS_CACHE = 'DISCOVER_COLLECTIONS_CACHE';

export const useGetDiscoverCollections = () => {
    const { params } = useSearchParamsState<{ chain: SupportedNetworkName }>();

    return useQuery({
        queryKey: [DISCOVER_COLLECTIONS_CACHE, JSON.stringify(params)],
        queryFn: ({ signal }) =>
            callGetDiscoverCollections({
                settings: { signal },
                query: params,
            }),
        retry: true,
        refetchInterval: 10 * 1000,
        select: (res) => {
            if (res.ok && res.value) return res.value;
        },
    });
};
